import script from "./addbank.vue?vue&type=script&setup=true&lang=js"
export * from "./addbank.vue?vue&type=script&setup=true&lang=js"

import "./addbank.vue?vue&type=style&index=0&id=f9fca688&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9fca688"]])

export default __exports__